/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useMemo } from 'react';
import { Chip } from 'primereact/chip';
import { classNames } from 'primereact/utils';

export interface LogSelectorsProps {
  logsHref: string[];
  selectedLogId: string | undefined;
  setSelectedLogId: (logId: string | undefined) => void;
  className?: string | undefined;
}
export const LogSelectors: React.FC<LogSelectorsProps> = (props) => {
  const { logsHref, className, selectedLogId, setSelectedLogId } = props;

  const getLogs = useMemo(() => {
    if (Array.isArray(logsHref)) {
      return logsHref.map((el: string) => {
        const url = new URL(el);
        const suffix = url.pathname.split('/').reverse()[0];
        return { name: suffix, url: el };
      });
    }
    return [];
  }, [logsHref]);

  const handleOpen = (url: string) => {
    window.open(url);
  };

  return (
    <div className={classNames(className)}>
      {getLogs.map((el, index) => (
        <Chip
          className={classNames('mx-1 cursor-pointer my-1 pr-0', el.name.includes(selectedLogId) && 'bg-primary')}
          onClick={() => {
            setSelectedLogId?.(el.name);
          }}
          key={index}
          template={
            <>
              <span>{el.name}</span>

              <span className="bg-bluegray-500 ml-2 border-circle w-2rem h-2rem flex align-items-center justify-content-center">
                <i
                  onClick={(ev) => {
                    handleOpen(el.url);
                    ev.stopPropagation();
                  }}
                  className="pi pi-download text-white"
                />
              </span>
            </>
          }
        />
      ))}
    </div>
  );
};
